import { isNil } from "lodash";
import { LoginError, FavoritesPage } from "./_helpers/constants";
import Auth0Helpers from "./_helpers/auth0-helpers";
import SessionStorage from "./_helpers/session-storage";

export default class Login {}

(function () {
  const auth0Helpers = new Auth0Helpers();
  const sessionStorage = new SessionStorage();

  document.addEventListener("DOMContentLoaded", async function () {
    if (!window.auth0) {
      await auth0Helpers.configureClient(window);
    }
    checkErrorFlow();
    const isAuthenticated = await auth0Helpers.isAuthenticated();

    await hideUserMenuDropdown(window, auth0Helpers, sessionStorage);

    $("[js-user-login]").on("click", async function () {
      const userIsAuthenticated = await window.auth0.isAuthenticated();
      if (userIsAuthenticated) {
        if ($(".tc-user-menu-dropdown").is(":visible")) {
          $(".tc-user-menu-dropdown").removeClass("show");
        } else {
          $(".tc-user-menu-dropdown").addClass("show");
        }
      } else {
        auth0Helpers.login();
      }
    });

    $("[js-user-logout]").on("click", function () {
      sessionStorage.deleteUserData();

      auth0Helpers.logout();
    });

    if (isAuthenticated) {
      // show the gated content
      return;
    }

    const query = window.location.search;
    if (query.includes("code=") && query.includes("state=")) {
      // Process the login state
      await window.auth0.handleRedirectCallback();

      await hideUserMenuDropdown(window, auth0Helpers, sessionStorage);

      // Use replaceState to redirect the user away and remove the querystring parameters
      window.history.replaceState({}, document.title, "/");
    }
  });
})();

const checkErrorFlow = () => {
  const query = window.location.search;

  if (
    query.indexOf("error=") > -1 &&
    query.indexOf("error_description=") > -1
  ) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const auth0Helpers = new Auth0Helpers();
    if (params.error_description === LoginError.EmailNotVerified) {
      auth0Helpers.logout(
        `${window.location.origin}/my-account/email-not-verified`,
      );
    } else {
      window.location.href = `${window.location.origin}/my-account/error`;
    }
  }
};

const getFirstAccess = (userData) => {
  return (
    isNil(userData) ||
    isNil(userData.firstAccess) ||
    (!isNil(userData.firstAccess) && userData.firstAccess === true)
  );
};

const manageFirstAccess = async (userData, auth0Helpers, isFirstAccess) => {
  if (isFirstAccess) {
    userData.firstAccess = false;
    await auth0Helpers.updateFirstAccess(userData.sub, userData);
  }
};

const hideUserMenuDropdown = async (w, auth0Helpers, sessionStorage) => {
  const isAuthenticated = await auth0Helpers.isAuthenticated();
  if (!isAuthenticated) {
    $(".tc-user-menu-dropdown").hide();
    $(".tc-user-login-btn").show();
  } else {
    const userData = await auth0Helpers.getUserData();

    const isFirstAccess = getFirstAccess(userData);

    if (isFirstAccess && w.location.pathname !== FavoritesPage.PagePath) {
      w.location.href = `${w.location.origin}${FavoritesPage.PagePath}`;
    } else if (
      isFirstAccess &&
      w.location.pathname === FavoritesPage.PagePath
    ) {
      manageFirstAccess(userData, auth0Helpers, isFirstAccess);
    }

    $(".tc-user-login-btn").hide();
    $(".tc-user-menu-profile").addClass("show");

    if (userData.name) {
      const profileName = userData.name.substring(0, 1);
      $(".tc-user-menu-profile span").text(profileName);
    }

    sessionStorage.setUserData(userData);
  }
};
